export default __webpack_public_path__ + "static/Muhammad_Arslan-f1fd56b17e6cbfee17bcf08cc1fa6102.png";